export enum NavigationRegions {
  PrimaryMenu = '@trustedshops/tswp-carrier-b2b:primary-menu',
  SecondaryMenu = '@trustedshops/tswp-carrier-b2b:secondary-menu',
  TertiaryMenu = '@trustedshops/tswp-carrier-b2b:tertiary-menu',
  LegalMenu = '@trustedshops/tswp-carrier-b2b:legal-menu',
  MetaMenu = '@trustedshops/tswp-carrier-b2b:meta-menu'
}
